import UserHelpers from "../../apps/data/user/UserHelpers";

import WorkspaceActions from "../../apps/data/workspace/WorkspaceActions";
import { WorkspaceWarningDetailsType } from "../../apps/data/workspace/WorkspaceWarningDetails";
import * as ZeplinApi from "../api";

import { organizationPrefs } from "../prefs";

import { getDateDifference } from "./date";

export async function displayBillingAddressBannerIfNecessary({
    organizationId,
    organizationStatus,
    subscriptionStatus,
    currentUserRole
}: {
    organizationId: string | undefined | null;
    organizationStatus: string | undefined | null;
    subscriptionStatus: string | undefined | null;
    currentUserRole: string | undefined | null;
}) {
    if (!organizationId) {
        return;
    }

    const missingAddressBannerLastSeenDate = await organizationPrefs.get(organizationId, "missingAddressBannerLastSeenDate");
    if (missingAddressBannerLastSeenDate && getDateDifference("d", missingAddressBannerLastSeenDate, new Date()) < 1) {
        return;
    }

    const userPaymentPlan = UserHelpers.getUserPaymentPlan();

    let billingInfo;
    if (organizationId === "user" &&
        userPaymentPlan &&
        !["free", "bff", "non_profit"].includes(userPaymentPlan.toLowerCase())) {
        billingInfo = await ZeplinApi.getUserBilling();
    } else if (organizationStatus &&
        subscriptionStatus !== "trialing" &&
        ["active", "frozen"].includes(organizationStatus) &&
        currentUserRole &&
        ["king", "queen"].includes(currentUserRole)) {
        billingInfo = await ZeplinApi.getOrganizationBilling(organizationId);
    }

    if (!billingInfo || billingInfo.billing.address) {
        return;
    }

    WorkspaceActions.setWorkspaceWarningDetails({
        type: WorkspaceWarningDetailsType.BillingAddressInfo,
        organizationId
    });
}
